<template>
  <div class="clauserow" style="margin-left: 10px;">
    <div class="clauserowheader">
      <div class="text-block-4">{{ contract.name }}</div>
      <a href="#" @click="$emit('sharePressed', contract)" class="link-block w-inline-block"
        ><img src="static/images/back-arrow.png" alt="" class="image-2"
      /></a>
    </div>
    <!--<div class="clauserowbody">
      <div class="text-block-4">
        {{ truncatedText }}
      </div>
    </div>-->
  </div>
</template>

<script>
import contractmixin from './mixins/contract.mixin'
export default {
  mixins: [contractmixin]
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/OverviewContractItem.vue